import React, { useState } from 'react';

import { ModalContent } from '../styles';
import { Modal, Header, Body, Footer, FooterButton } from '../modalElements';
import { Checkbox } from 'components/Checkbox/Checkbox';
import ConfirmModal from 'components/Modals/confirmModal';

export default React.memo(({ isMobile, isCodeTest, confirm, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isInvitedToSpectate, setIsInvitedToSpectate] = useState(false);
  const [showMobileWarningModal, setShowMobileWarningModal] = useState(false);

  const hideModal = (value) => {
    setIsOpen(false);
    if (value && isMobile) return setShowMobileWarningModal(true);
    return confirm(value, isInvitedToSpectate);
  };

  return (
    <>
      {showMobileWarningModal && (
        <ConfirmModal
          title="Confirmation"
          text="A computer is preferable when taking this test. Do you still want to continue anyway?"
          onConfirm={() => confirm(true)}
          onCancel={() => confirm(false)}
        />
      )}
      <Modal isOpen={isOpen} className="modal-container">
        <Header className="test-start-modal-title">Instructions</Header>
        <Body>
          <ModalContent>
            <div
              dangerouslySetInnerHTML={{
                __html: children,
              }}
            />
          </ModalContent>
          <Checkbox checked={isAgreed} onChange={() => setIsAgreed(!isAgreed)} label="I have read the instructions" />
        </Body>
        <Footer>
          <FooterButton label="Close" onClick={() => hideModal(false)} autoFocus />
          {isCodeTest && (
            <FooterButton
              label="Invite to spectate"
              selected={isInvitedToSpectate}
              onClick={() => setIsInvitedToSpectate(!isInvitedToSpectate)}
            />
          )}
          <FooterButton label="Start" onClick={() => hideModal(true)} disabled={!isAgreed} />
        </Footer>
      </Modal>
    </>
  );
});
